"use client";
import { Navigate } from "react-router-dom";

interface Props {
  landingPage?: string;
}

export default function Fallback(props: Props) {
  return props.landingPage ? <Navigate to={props.landingPage} /> : <></>;
}
